import { formatDate } from '@angular/common';
import { Resource } from 'idea-toolbox';

import { UserPrivacyPreferences } from './user.model';

export class Registration extends Resource {
  personType: PersonTypes;
  firstName: string;
  lastName: string;
  businessName: string;
  taxCode: string;
  birthdate: string;
  email: string;
  phone: string;
  policyNumber: string;
  password: string;
  confirmPassword: string;
  privacyPreferences: UserPrivacyPreferences;

  load(x: any): void {
    super.load(x);
    this.personType = this.clean(x.personType, String, PersonTypes.PRIVATE);
    if (this.personType === PersonTypes.PRIVATE) {
      this.firstName = this.clean(x.firstName, String);
      this.lastName = this.clean(x.lastName, String);
      this.birthdate = this.clean(x.birthdate, String);
    } else {
      delete this.firstName;
      delete this.lastName;
      delete this.birthdate;
    }
    if (this.personType === PersonTypes.COMPANY) this.businessName = this.clean(x.businessName, String);
    else delete this.businessName;
    this.taxCode = this.clean(x.taxCode, String);
    this.email = this.clean(x.email, String);
    this.phone = this.clean(x.phone, String);
    this.policyNumber = this.clean(x.policyNumber, String);
    this.password = this.clean(x.password, String);
    this.confirmPassword = this.clean(x.confirmPassword, String);
    this.privacyPreferences = new UserPrivacyPreferences(x.privacyPreferences ?? x.privacy);
  }

  validate(): string[] {
    const e = super.validate();
    if (!Object.values(PersonTypes).includes(this.personType)) e.push('personType');
    if (this.personType === PersonTypes.PRIVATE) {
      if (this.iE(this.firstName)) e.push('firstName');
      if (this.iE(this.lastName)) e.push('lastName');
      const today = formatDate(new Date(), 'yyyy-MM-dd', 'it-IT');
      if (this.iE(this.birthdate) || this.birthdate > today) e.push('birthdate');
    }
    if (this.personType === PersonTypes.COMPANY && this.iE(this.businessName)) e.push('businessName');
    if (this.iE(this.taxCode)) e.push('taxCode');
    if (this.iE(this.email, 'email')) e.push('email');
    if (this.iE(this.phone)) e.push('phone');
    if (this.iE(this.policyNumber)) e.push('policyNumber');
    if (this.iE(this.password)) e.push('password');
    if (this.iE(this.confirmPassword) || this.password !== this.confirmPassword) e.push('confirmPassword');
    this.privacyPreferences.validate().forEach(ea => e.push(`privacyPreferences.${ea}`));
    return e;
  }
}

export enum PersonTypes {
  PRIVATE = '1',
  COMPANY = '2'
}
